export default "__VITE_ASSET__Dj$jvyYW__"